const state = {
  //选择的账号
  adCount: null,
  advertiserIdList: [],
  promotedObjectType: "APP_IOS", // 推广目标

  //分配规则
  split_rule: {
    targeting: "adset",
    creativeGroups: "adset",
    textGroups: "adset",
  },
  //推广计划
  draft_campaign: {
    campaignMode: "add",
  },
  // 基础设置
  draft_adset: {
    //广告计划名称
    name_rule: "",
    nameRule: "{Objective}{Placement}",
    placementType: "VIDEO",
    videoCheckList: [
      "SITE_SET_KANDIAN",
      "SITE_SET_QQ_MUSIC_GAME",
      "SITE_SET_TENCENT_NEWS",
      "SITE_SET_TENCENT_VIDEO",
      "SITE_SET_MOBILE_UNION",
      "SITE_SET_WECHAT",
    ],
  },
  // 定向包
  draft_targeting: {},
  // 预算与出价
  draft_budgets: {},
  // 预算与出价数据，用于回显
  origin_draft_budgets: {},
  // 创意组和创意标题
  draft_creative: {
    textGroups: [],
    creativeGroups: {},
  },
  // 创意组和创意标题，用于回显
  origin_draft_creative: {
    textGroups: [],
    creativeGroups: {},
  },
  // 其他设置
  draft_extra_config: {},
  // 选择模板
  templateDetail: {},
};

const actions = {};

const mutations = {
  //设置账号数据
  setadCount_gdt(state, data) {
    state.adCount = data;
    state.advertiserIdList = [];
    data.map((item) => {
      state.advertiserIdList.push(item.advertiserId);
    });
  },
  //设置推广计划
  set_draft_campaign_gdt: (state, data) => {
    state.draft_campaign = data;
  },
  // 修改推广计划类型
  set_draft_campaign_mode_gdt: (state, data) => {
    state.draft_campaign.campaignMode = data;
  },
  // 推广目标类型
  set_spread_target_gdt(state, data) {
    state.promotedObjectType = data;
  },

  // 基础设置
  set_basic_draft_adset_gdt(state, data) {
    state.draft_adset = data;
  },
  // 设置应用id
  set_basic_draft_adset_promotedId_gdt(state, data) {
    state.draft_adset.promotedObjectId = data.promotedObjectId;
    state.draft_adset.promotedObjectName = data.promotedObjectName;
    state.draft_adset.channelPackageItems = data.channelPackageItems;
  },
  // 定向包
  set_draft_targeting_gdt(state, data) {
    state.draft_targeting = data;
  },

  //设置预算和出价
  set_draft_budgets_gdt: (state, data) => {
    state.draft_budgets = data;
  },

  //设置预算和出价原始数据，用于回显
  set_origin_draft_budgets_gdt: (state, data) => {
    state.origin_draft_budgets = data;
  },

  // 设置创意组
  set_draft_creative_gdt: (state, data) => {
    state.draft_creative.creativeGroups = data;
  },

  set_creative_groupName_gdt: (state, data) => {
    //修改创意组名称
    let { name, id } = data;
    let curGroup = state.draft_creative.creativeGroups.find((item) => item.itemId === id);
    if (curGroup) {
      curGroup.groupName = name;
    }
  },

  // 设置创意标题
  set_draft_creative_title_gdt: (state, data) => {
    state.draft_creative.textGroups = data;
  },

  //
  set_origin_draft_creative_gtd: (state, data) => {
    state.origin_draft_creative = data;
  },

  // 设置其他设置
  set_draft_extra_config_gdt: (state, data) => {
    state.draft_extra_config = data;
  },

  //设置分配规则
  set_split_rule_gdt: (state, data) => {
    state.split_rule[data.key] = data.value;
  }, //用
  set_allsplit_rule_gdt: (state, data) => {
    state.split_rule = data;
  }, //用
};

export default {
  state,
  actions,
  mutations,
};
